import { alpha, Box, styled } from "@mui/material";

export const AssistantSummary = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: theme.spacing(4),
}));

export const AssistantSummaryIcon = styled(Box)(({ theme }) => ({
  display: "grid",
  placeItems: "center",
  width: theme.spacing(9),
  height: theme.spacing(9),
  borderRadius: theme.shape.borderRadius[5],
  backgroundColor: alpha(
    theme.palette.secondary.main,
    theme.palette.action.selectedOpacity
  ),
  color: theme.palette.primary.main,
  ...theme.typography.h3,
}));

export const AssistantSummaryCounts = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: theme.spacing(5),
}));

export const AssistantSummaryList = styled(Box)({ width: "100%" });

export const AssistantSummaryRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  textAlign: "left",
  gap: theme.spacing(3),
  padding: theme.spacing(3, 0),
  borderBottom: `1px solid ${theme.palette.custom.semantic.border.subtle}`,
}));
